"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freeAccessSuccessLoadCreator = void 0;
var consts_1 = require("../consts");
var freeAccessSuccessLoadCreator = function (event) {
    var eventData = {
        action: 'freeaccesssuccess',
        event: 'freeaccesssuccess',
        eventInfo: 'freeaccesssuccess',
        freeaccess: {
            productName: event.eventData.freeaccess.productName || consts_1.NOT_AVAILABLE,
            productCat: event.eventData.freeaccess.productCat || consts_1.NOT_AVAILABLE,
            popupTime: event.eventData.freeaccess.popupTime || consts_1.NOT_AVAILABLE,
        },
    };
    return eventData;
};
exports.freeAccessSuccessLoadCreator = freeAccessSuccessLoadCreator;
